import { useCallback } from 'react';
import history from 'services/history';
import { navigateToProntuario } from 'utils/prontuarioNav';

export function useAtividades() {
  const handleEcg = useCallback((atividade) => {
    history.push(`/formulario-ecg/${atividade.CODLAUDO}`);
  }, []);

  // ECG por IA desativado — não usado hoje.
  // const handleEcgPorIA = useCallback(async (atividade) => {
  //   try {
  //     const ecg = await selectEcgById(atividade.CODLAUDO);
  //     history.push('/formEcgIA', { data: ecg });
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || 'Erro ao buscar ECG');
  //   }
  // }, []);

  const handleTilt = useCallback((atividade) => {
    history.push(`/formulario-tilt/${atividade.CODLAUDO}`);
  }, []);

  const handleProntuario = useCallback((atividade) => {
    navigateToProntuario(atividade.CODPAC);
  }, []);

  return {
    handleEcg,
    // handleEcgPorIA,
    handleTilt,
    handleProntuario,
  };
}
